import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {FigureControl} from "../../../PageBuilderPr/Controls/FigureControl";
import {IconControl} from "../../../PageBuilderPr/Controls/IconControl";
import {QRControl} from "../../../PageBuilderPr/Controls/QRControl";
import {HtmlControl} from "../../../PageBuilderPr/Controls/HtmlControl";
import {ImageControl} from "../../../PageBuilderPr/Controls/ImageControl";
import {FigureControlOptions} from "../../../PageBuilderPr/Controls/FigureControl.Options";
import {IconControlOptions} from "../../../PageBuilderPr/Controls/IconControl.Options";
import {QRControlOptions} from "../../../PageBuilderPr/Controls/QRControl.Options";
import {HtmlControlOptions} from "../../../PageBuilderPr/Controls/HtmlControl.Options";
import {ImageControlOptions} from "../../../PageBuilderPr/Controls/ImageControl.Options";
import {PRControlTypes} from "../../../PageBuilderPr/PRControlFactory";
import {InvoiceDetailControl} from "./InvoiceDetailControl";
import {InvoiceDetailControlOptions} from "./InvoiceDetailControl.Options";


export class WPFormControlFactory {
    static GetControl(controlType:string):PDFControlBase
    {
        switch (controlType) {
            case WPFormControlTypeEnum.InvoiceDetail:
                return new InvoiceDetailControl();
            default:
                return null;
        }
    }


}

export class WPFormControlOptionsFactory{
    static GetControlOptions(type:string)
    {
        switch (type) {
            case WPFormControlTypeEnum.InvoiceDetail:
                return new InvoiceDetailControlOptions();
            default:
                return null;
        }
    }


}



export enum WPFormControlTypeEnum{
    InvoiceDetail='InvoiceDetail'
}

